import styles from '../../styles/modules/mortgage/MortgageStepsItem.module.scss';

const MortgageSteps = ({ number, title, duration, description }) => {
  return (
    <div className={styles.step}>
      <div className={styles.number}>{number}</div>
      <div className={styles.title}>{title}</div>
      <div className={styles.duration}>{duration}</div>
      <div className={styles.description}>{description}</div>
    </div>
  );
};

export default MortgageSteps;
